(() => {
  const openBase = '.day-camping-base-open-js';
  const closeBase = '.day-camping-base-close-js';
  const baseInfo = '.day-camping-base-info-js';
  const openOption = '.day-camping-option-open-js';
  const closeOption = '.day-camping-option-close-js';
  const optionInfo = '.day-camping-option-info-js';
  const openCoupon = '.day-camping-coupon-open-js';
  const closeCoupon = '.day-camping-coupon-close-js';
  const couponInfo = '.day-camping-coupon-info-js';
  const openSubscription = '.day-camping-subscription-open-js';
  const closeSubscription = '.day-camping-subscription-close-js';
  const subscriptionInfo = '.day-camping-subscription-info-js';

  const init = () => {
    if (location.href.indexOf('customer/day_camping') < 1 ) {
      return;
    }

    $('body')
      .on('click', openBase, openBaseInfo)
      .on('click', closeBase, closeBaseInfo)
      .on('click', openOption, openOptionInfo)
      .on('click', closeOption, closeOptionInfo)
      .on('click', openCoupon, openCouponInfo)
      .on('click', closeCoupon, closeCouponInfo)
      .on('click', openSubscription, openSubscriptionInfo)
      .on('click', closeSubscription, closeSubscriptionInfo);
  }

  const openBaseInfo = () => {
    $(openBase).fadeOut().attr('style', 'display: none !important');
    $(closeBase).fadeIn().attr('style', 'display: block !important');
    $(baseInfo).fadeIn().attr('style', 'display: block !important');
  }

  const closeBaseInfo = () => {
    $(openBase).fadeIn().attr('style', 'display: block !important');
    $(closeBase).fadeOut().attr('style', 'display: none !important');
    $(baseInfo).fadeOut().attr('style', 'display: none !important');
  }

  const openOptionInfo = () => {
    $(openOption).fadeOut().attr('style', 'display: none !important');
    $(closeOption).fadeIn().attr('style', 'display: block !important');
    $(optionInfo).fadeIn().attr('style', 'display: block !important');
  }

  const closeOptionInfo = () => {
    $(openOption).fadeIn().attr('style', 'display: block !important');
    $(closeOption).fadeOut().attr('style', 'display: none !important');
    $(optionInfo).fadeOut().attr('style', 'display: none !important');
  }

  const openCouponInfo = () => {
    $(openCoupon).fadeOut().attr('style', 'display: none !important');
    $(closeCoupon).fadeIn().attr('style', 'display: block !important');
    $(couponInfo).fadeIn().attr('style', 'display: block !important');
  }

  const closeCouponInfo = () => {
    $(openCoupon).fadeIn().attr('style', 'display: block !important');
    $(closeCoupon).fadeOut().attr('style', 'display: none !important');
    $(couponInfo).fadeOut().attr('style', 'display: none !important');
  }

  const openSubscriptionInfo = () => {
    $(openSubscription).fadeOut().attr('style', 'display: none !important');
    $(closeSubscription).fadeIn().attr('style', 'display: block !important');
    $(subscriptionInfo).fadeIn().attr('style', 'display: block !important');
  }

  const closeSubscriptionInfo = () => {
    $(openSubscription).fadeIn().attr('style', 'display: block !important');
    $(closeSubscription).fadeOut().attr('style', 'display: none !important');
    $(subscriptionInfo).fadeOut().attr('style', 'display: none !important');
  }

  $(init)
})();
